//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import Model from "@/models/yunMobile";
import PayCommon from "./PayCommon";
import { calc } from '@/utils/calc';
export default {
  components: {
    PayCommon,
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer")
  },
  data() {
    return {
      dialogTableVisible: false,
      checked: true,
      activeName: -1,
      tollList: [],
      code: "",
      showViewer: false,
      showLinkBtn: true,
      passState: [
        { key: 1, value: "普通临时车" },
        { key: 2, value: "月卡车" },
        { key: 3, value: "免费车" },
        { key: 4, value: "临时车1" },
        { key: 5, value: "临时车2" },
        { key: 6, value: "临时车3" },
        { key: 7, value: "临时车4" },
        { key: 8, value: "临时车5" },
        { key: 9, value: "临时车6" },
        { key: 10, value: "临时车7" },
        { key: 11, value: "临时车8" },
        { key: 12, value: "临时车9" },
        { key: 13, value: "临时车10" },
        { key: 14, value: "贵宾车" }
      ],
      isIndeterminate: false,
      pageFlag: true,
      isAdvancedPay: "",
      cardCode: this.$route.query.cardCode ? this.$route.query.cardCode : localStorage.getItem('cardCode'),
      arrearsAmounts: [],
      orderIds: [],
      authCode:'',
    }
  },
  computed: {
    ...mapGetters("yunMobile", {
      data: "getCarin"
    }),
    arrearSum() {
      let sum = 0
      this.arrearsAmounts.forEach(item => {
        sum += item
      })
      return (sum / 100)
    },
    sumMoney() {
      if (this.data.zongjine && (this.arrearSum || this.checked === true)) {
        return calc.add(Number(this.data.realityMoney), this.arrearSum)
      } else {
        return this.data.realityMoney
      }

    }
  },
  mounted() {
    if (this.$isZfb) {
      ap.getAuthCode({
        appId: '2016060201473949',
        scopes: ['auth_user'],
      }, (res) => {
        this.authCode = res.authCode 
      });
    }
    this.createdFunc();
    if (this.data.zongjine) {
      Model.arrearsList({ plateNo: this.data.mediaNo, plateColor: 1 }).then(res => {
        res.data.data.content.forEach(item => {
          item.isCheck = true
          this.orderIds.push(item.orderId)
          this.arrearsAmounts.push(item.arrearsAmount)
        });
        this.tollList = res.data.data.content
      })
    }

  },
  created() {
    if (this.$route.query.showbtn === 'false' || sessionStorage.getItem('showbtn') === 'false') {
      this.showLinkBtn = false
    }
    this.isAdvancedPay = this.$route.query.isAdvancedPay;
    if (this.$route.query.params) {
      sessionStorage.setItem("wxPayParams", this.$route.query.params);
    }
  },
  methods: {
    handleChange(e) {
      this.isIndeterminate = false
      this.arrearsAmounts = []
      this.orderIds = []
      if (e === true) {
        this.tollList.forEach(item => {
          item.isCheck = true
          this.arrearsAmounts.push(item.arrearsAmount)
          this.orderIds.push(item.orderId)
        })
      } else {
        this.tollList.forEach(item => {
          item.isCheck = false
        })
      }
    },
    checkedAll(orderId, arrearsAmount, isCheck) {
      if (isCheck === true) {
        this.arrearsAmounts.push(arrearsAmount)
        this.orderIds.push(orderId)
      } else {
        let arrearsAmounts = JSON.parse(JSON.stringify(this.arrearsAmounts))
        let orderIds = JSON.parse(JSON.stringify(this.orderIds))
        let i = 0
        orderIds.forEach((item, index) => {
          if (item === orderId) {
            i = index
          }
        })
        arrearsAmounts.splice(i, 1)
        orderIds.splice(i, 1)
        this.arrearsAmounts = arrearsAmounts
        this.orderIds = orderIds
      }
      this.isIndeterminate = this.orderIds.length > 0 && this.orderIds.length < this.tollList.length
    },
    handleShow() {
      this.dialogTableVisible = true;
    },
    linkFunc() {
      this.$router.push(
        `/mobile/yunMobile/branch/enterCar/${this.data.parkNo}/${this.data.passNo
        }?isLink=1&cardCode=${this.cardCode}`
      );
    },
    createdFunc() {
      if (this.$route.params.carNo == 666) {
        this.pageFlag = false;
        this.wxPay();
      }
    },
    passStateFilter(value) {
      let state = this.passState.find(item => item.key == value);
      return state ? state.value : "";
    },
    async payReturn() {
      let { data } = await Model.payReturn({
        payMoney: 0,
        payTime: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
        payType: -1,
        orderNo: this.data.orderNo,
        OrderDesc: `${this.data.mediaNo}支付${this.data.parkname}停车费`
      });
      data.success ? this.$layer.msg(data.msg) : this.$layer.msg(data.error);
      if (data.success) {
        this.$router.push(
          `/mobile/yunMobile/enterCar/${this.data.parkNo}/${this.data.passNo}`
        );
        localStorage.setItem("carNo", this.data.mediaNo);
      } else {
        this.$router.push(`/mobile/yunMobile/confirmMsg/${this.data.mediaNo}`);
      }
    },
    wxPay() {
      var params = JSON.parse(sessionStorage.getItem("wxPayParams"));
      params.zhifuFs = "weChat_jsApi";
      params.carType = this.data.cartype;
      if (this.$route.params.carNo == 666) {
        params.notifyType = JSON.parse(
          sessionStorage.getItem("wxPayParams")
        ).notifyType;
      } else {
        params.notifyType = 1;
      }

      if (params.pageType == "recharge") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              this.$layer.msg(res.msg || res.message);
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "renewalDetails") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              this.$layer.msg(res.msg || res.message);
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "openCardDetails") {
        if (this.$route.query.code) {
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              this.$layer.msg(res.msg || res.message);
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            paySuccess: res => {
              this.$layer.msg("支付成功");
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            },
            payFail: res => {
              setTimeout(() => {
                window.open(params.pageUrl);
              }, 1000);
            }
          });
        }
      } else if (params.pageType == "MonitorRenewal") {
        this.$refs.payCommon.payByWx({
          params,
          fail: res => {
            this.$layer.msg(res.msg || res.message);
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          },
          paySuccess: res => {
            this.$layer.msg("支付成功");
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          },
          payFail: res => {
            setTimeout(() => {
              window.open(params.pageUrl);
            }, 1000);
          }
        });
      }
    },
    pay() {
      console.log(this.data);
      if (this.data.realityMoney == 0) {
        if (sessionStorage.getItem("isNoCar") == 1) {
          if (this.$route.params.carNo == 2) {
            Model.openPark({
              parkNo: this.data.parkNo,
              passNo: this.data.passNo,
              carNo: this.data.mediaNo,
              carType: this.data.passtype,
              OrderDesc: `${this.data.mediaNo}支付${this.data.parkname}停车费`
            }).then(res => {
              this.$router.replace({ path: "/mobile/yunMobile/resultPay" });
              //防止页面后退
              history.pushState(null, null, document.URL);
              window.addEventListener("popstate", function () {
                history.pushState(null, null, document.URL);
              });
              //                          this.$router.push(`/mobile/yunMobile/resultPay`)
            });
          } else {
            this.payReturn();
          }
        } else {
          this.$layer.msg("费用为0，无需支付");
          if (this.$route.params.carNo == 2) {
            this.$router.push(
              `/mobile/yunMobile/branch/enterCar/${this.data.parkNo}/${this.data
                .passNo || -1}?cardCode=${this.cardCode}`
            );
          } else {
            this.$router.push(
              `/mobile/yunMobile/enterCar/${this.data.parkNo}/${this.data
                .passNo || -1}?cardCode=${this.cardCode}`
            );
          }
        }
      } else {
        let params = {}
        if (this.data.zongjine && (this.arrearSum || this.checked === true)) {
          params = {
            orderNo: this.data.orderNo,
            OrderAmount: this.sumMoney,
            zongbishu: this.orderIds.length,
            zongjine: this.arrearSum * 100,
            gsBh: this.data.gsbh,
            xmBh: this.data.xmbh,
            parkNo: this.data.parkNo,
            tollPayRsq: this.data.tollPayRsq,
            carType: this.data.cartype,
            OrderDesc: `${this.data.mediaNo}支付${this.data.parkname}停车费`,
            notifyType: 1,
            orderIds: this.orderIds,
            arrearsAmounts: this.arrearsAmounts
          }
        } else {
          params = {
            orderNo: this.data.orderNo,
            OrderAmount: this.sumMoney,
            gsBh: this.data.gsbh,
            xmBh: this.data.xmbh,
            parkNo: this.data.parkNo,
            tollPayRsq: this.data.tollPayRsq,
            carType: this.data.cartype,
            OrderDesc: `${this.data.mediaNo}支付${this.data.parkname}停车费`,
            notifyType: 1
          }
        }
        if (this.$isWx) {
          params.zhifuFs = "weChat_jsApi";
          this.$refs.payCommon.payByWx({
            params,
            fail: res => {
              this.$layer.msg(res.error || res.message);
              if (sessionStorage.getItem('isEnterPhone') === 'true') {
                this.$router.push(
                  `/mobile/yunMobile/branch/enterPhone/${this.data.parkNo}/${this
                    .data.passNo || -1}?cardCode=${this.cardCode}`
                );
              } else {
                if (this.$route.params.carNo == 2) {
                  this.$router.push(
                    `/mobile/yunMobile/branch/enterCar/${this.data.parkNo}/${this
                      .data.passNo || -1}?cardCode=${this.cardCode}`
                  );
                } else {
                  this.$router.push(
                    `/mobile/yunMobile/confirmMsg/${this.res.mediaNo}`
                  );
                }
              }

            },
            paySuccess: res => {
              if (this.$route.params.carNo == 2) {
                if (this.data.ishave == 0) {
                  Model.openPark({
                    parkNo: this.data.parkNo,
                    passNo: this.data.passNo,
                    carNo: this.data.mediaNo,
                    carType: this.data.passtype
                  });
                }
                this.$router.replace({
                  path: `/mobile/yunMobile/branch/enterCar/${this.data.parkNo
                    }/${this.data.passNo || -1}?cardCode=${this.cardCode}&isExpense=-1`
                });
              } else {
                this.$router.push(
                  `/mobile/yunMobile/enterCar/${this.data.parkNo}/${this.data.passNo
                  }`
                );
              }
              localStorage.setItem("carNo", this.data.mediaNo);
            },
            payFail: res => {
              if (sessionStorage.getItem('isEnterPhone') === 'true') {
                this.$router.push(
                  `/mobile/yunMobile/branch/enterPhone/${this.data.parkNo}/${this
                    .data.passNo || -1}?cardCode=${this.cardCode}`
                );
              } else {
                if (this.$route.params.carNo == 2) {
                  this.$router.push(
                    `/mobile/yunMobile/branch/enterCar/${this.data.parkNo}/${this
                      .data.passNo || -1}?cardCode=${this.cardCode}`
                  );
                } else {
                  this.$router.push(
                    `/mobile/yunMobile/confirmMsg/${this.res.mediaNo}`
                  );
                }
              }
            }
          });
        } else if (this.$isZfb) {
          console.log(params);
          params.zhifuFs = "alipay_scan";
          params.code = this.authCode
          this.$refs.payCommon.payByZfb({
            params,
            success: res => {
            },
            fail: res => {
              this.$layer.msg(res.error || res.message);
              if (this.$route.params.carNo == 2) {
                this.$router.push(
                  `/mobile/yunMobile/branch/enterCar/${this.data.parkNo}/${this
                    .data.passNo || -1}?cardCode=${this.cardCode}`
                );
              } else {
                this.$router.push(
                  `/mobile/yunMobile/confirmMsg/${this.res.mediaNo}`
                );
              }
            }
          });
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/confirmPay.vue